<template>
  <div class="box" v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>

    <div class="table_wrap">
      <div class="count_data">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <div>
              <h3>Master A/C: {{ shopData.merchantNum }}</h3>
              <h3>Merhant ID: {{ shopData.shopNum }}</h3>
              <h3>Shop Name: {{ shopData.nameChi }}</h3>
            </div>
            <div>{{ language("salesRecord.updated") }}: {{ updatedTime }}</div>
          </div>

          <div>
            <h3>Daily Sales Reference : {{ dataObj.date }}</h3>
          </div>
          <div class="count_table">
            <el-table :data="countTableData" style="width: 100%">
              <el-table-column prop="name" label="" width="180">
              </el-table-column>
              <el-table-column prop="order" label="Order" width="180">
              </el-table-column>
              <el-table-column
                prop="amount"
                label="Net Sales Amount"
                width="200"
              >
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
      <!--一本打开-->
      <div class="card_wrap">
        <div class="card">
          <!-- <div class="input">
          <input-card
            :title="language('salesRecord.transaction')"
            :dataArr="inputArr"
            labelPosition="top"
            @change="changeInput"
          ></input-card>
        </div> -->
          <div class="time">
            <el-card class="box-card" shadow="never">
              <div slot="header">
                <h4>{{ language("salesRecord.time") }}</h4>
              </div>
              <el-date-picker
                v-model="period"
                type="month"
                placeholder=""
                value-format="yyyy-MM"
              >
              </el-date-picker>
            </el-card>
          </div>
        </div>
        <div class="tips">{{ language("salesRecord.searchTips") }}</div>
        <div class="button_wrap">
          <el-button type="primary" @click="search">{{
            language("salesRecord.search")
          }}</el-button>
        </div>
      </div>
      <template
        v-if="
          dataObj && dataObj.recordVoList && dataObj.recordVoList.length > 0
        "
      >
        <el-button
          class="download"
          type="primary"
          @click="
            $utils.download(
              '/admin/merchant/report/exportSalesRecord',
              form,
              'code=sale_record'
            )
          "
          >{{ language("all.download") }}</el-button
        >
      </template>
      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :dataArr="dataObj.recordVoList"
        :refeshParams="refeshTable"
        :emptyText="language('salesRecord.emptyText')"
        :showIndex="false"
      ></cc-table>

      <div class="tips_text">
        <h4>Records will be updated in daily basis before 6 am</h4>
        <h4>
          "On Hold" Orders are the incomplete orders(e.g. Confirmed, Picked,
          DeliveredTM)
        </h4>
        <h4>
          "Delivered" Orders are the orders which already received by warehouse
        </h4>
        <h4>"CSCancel" are the orders which already cancelled by CS</h4>
        <h4>
          "Cancel" are the orders which already confirmed to cancel from both CS
          and merchant
        </h4>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import inputCard from "../../components/inputCard";

export default {
  components: {
    breadcrumb,
    inputCard,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("salesRecord.breadcrumbTitle"),
        list: [
          {
            name: this.language("salesRecord.breadcrumbList_1"),
          },
          {
            name: this.language("salesRecord.breadcrumbList_2"),
          },
        ],
      },
      inputArr: [
        {
          name: "Merhant ID",
          apiName: "Merhant ID",
          value: "",
          type: "select",
          options: [],
        },
      ],
      period: "",
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "date",
            lable: "Date",
            minWidth: 100,
          },
          {
            prop: "Order",
            lable: "Order",
            columns: [
              {
                prop: "onHold",
                lable: "OnHold",
              },
              {
                prop: "delivered",
                lable: "Delivered",
              },
              {
                prop: "cancel",
                lable: "Cancel",
              },
              {
                prop: "csCancel",
                lable: "CSCancel",
              },
              {
                prop: "refund",
                lable: "ReFunded",
              },
            ],
          },
          {
            prop: "Net Sales Amount",
            lable: "Net Sales Amount",
            columns: [
              {
                prop: "onHoldPrice",
                lable: "OnHold",
                render: (rows) => {
                  return this.$utils.toFixedDigit(rows.onHoldPrice, 2);
                },
              },
              {
                prop: "deliveredPrice",
                lable: "Delivered",
                render: (rows) => {
                  return this.$utils.toFixedDigit(rows.deliveredPrice, 2);
                },
              },
              {
                prop: "cancelPrice",
                lable: "Cancel",
                render: (rows) => {
                  return this.$utils.toFixedDigit(rows.cancelPrice, 2);
                },
              },
              {
                prop: "csCancelPrice",
                lable: "CSCancel",
                render: (rows) => {
                  return this.$utils.toFixedDigit(rows.csCancelPrice, 2);
                },
              },
              {
                prop: "refundPrice",
                lable: "ReFunded",
                render: (rows) => {
                  return this.$utils.toFixedDigit(rows.refundPrice, 2);
                },
              },
            ],
          },
        ],
        buttons: [],
      },
      countTableData: [
        { name: "On Hold", order: 0, amount: 0 },
        { name: "Delivered", order: 0, amount: 0 },
        { name: "Cancel", order: 0, amount: 0 },
        { name: "CSCancel", order: 0, amount: 0 },
        { name: "ReFunded", order: 0, amount: 0 },
      ],
      shopData: {},
      dataObj: {},
      updatedTime: "",
      form: {},
    };
  },
  methods: {
    getTime(n) {
      var time, y, m, d;
      time = new Date();
      y = time.getFullYear();
      m = time.getMonth() + 1;
      d = time.getDate();
      return y + "-" + m + "-" + d + n;
    },
    changeInput(e) {
      console.log(e);
    },
    search() {
      this.getData({});
    },
    getData(e) {
      this.loading = true;
      var time, y, m, d, h, f, s;
      time = new Date();
      y = time.getFullYear();
      m = time.getMonth() + 1;
      d = time.getDate();
      h = time.getHours();
      f = time.getMinutes();
      s = time.getSeconds();
      this.updatedTime =
        y +
        "-" +
        this.saveNum(m) +
        "-" +
        this.saveNum(d) +
        " " +
        this.saveNum(h) +
        ":" +
        this.saveNum(f) +
        ":" +
        this.saveNum(s);
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      e.geUpdateTime = this.getTime(" 00:00:00");
      e.leUpdateTime = this.getTime(" 23:59:59");
      e.period = this.period;
      this.form = e;
      this.ccRequest
        .do("admin/merchant/report/getSalesRecord?code=sale_record", e)
        .then((res) => {
          this.dataObj = res;
          this.countTableData = [
            {
              name: "On Hold",
              order: res.onHold,
              amount: this.$utils.toFixedDigit(res.onHoldPrice, 2),
            },
            {
              name: "Delivered",
              order: res.delivered,
              amount: this.$utils.toFixedDigit(res.deliveredPrice, 2),
            },
            {
              name: "Cancel",
              order: res.cancel,
              amount: this.$utils.toFixedDigit(res.cancelPrice, 2),
            },
            {
              name: "CSCancel",
              order: res.csCancel,
              amount: this.$utils.toFixedDigit(res.csCancelPrice, 2),
            },
            {
              name: "ReFunded",
              order: res.refund,
              amount: this.$utils.toFixedDigit(res.refundPrice, 2),
            },
          ];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    saveNum(n) {
      if (n < 10) {
        return "0" + n;
      } else {
        return n;
      }
    },
  },
  mounted() {
    var time, y, m, d, h, f, s;
    time = new Date();
    y = time.getFullYear();
    m = time.getMonth() + 1;
    d = time.getDate();
    h = time.getHours();
    f = time.getMinutes();
    s = time.getSeconds();
    this.period = y + "-" + m;
    let shopData = this.$shopData;
    this.shopData = shopData;

    this.getData({});
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  margin-bottom: 20px;
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;

    .input {
      width: 300px;
      margin-right: 20px;
      flex: 1;
    }
    .time {
      flex: 1;
      .box-card {
        height: 100%;
      }
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}

.button_wrap {
  margin-bottom: 20px;
}
.count_data {
  margin: 20px 0;
  .clearfix {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
      justify-content: space-between;
      h3 {
        margin-right: 40px;
      }
    }
  }
}
.count_table {
  margin: 20px 0;
}
.tips_text {
  padding: 40px 0;
  h4 {
    margin-bottom: 15px;
  }
}
</style>
<style>
.count_table .el-table th.is-leaf,
.count_table .el-table td {
  font-weight: 600;
  border: none;
}
.count_table .el-table--group::after,
.count_table.el-table--border::after,
.count_table .el-table::before {
  background-color: transparent;
}
.download {
  margin-bottom: 20px;
}
</style>